/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Carrier_NoticesInputs */

const en_nav_carrier_notices = /** @type {(inputs: Nav_Carrier_NoticesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carrier Notices`)
};

const es_nav_carrier_notices = /** @type {(inputs: Nav_Carrier_NoticesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avisos de transportistas`)
};

/**
* | output |
* | --- |
* | "Carrier Notices" |
*
* @param {Nav_Carrier_NoticesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_carrier_notices = /** @type {((inputs?: Nav_Carrier_NoticesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Carrier_NoticesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_carrier_notices(inputs)
	return es_nav_carrier_notices(inputs)
});